import { render, staticRenderFns } from "./WorkshopModal.vue?vue&type=template&id=46a61e01&"
import script from "./WorkshopModal.vue?vue&type=script&lang=js&"
export * from "./WorkshopModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports